module.exports = __webpack_public_path__ + "static/img/img-main-features-setcion-1-m@2x.935958c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-features-setcion-1-m@2x.png
// module id = km6w
// module chunks = 18